import { render } from "./TruckTrackingItem.vue?vue&type=template&id=d1ab2214&scoped=true"
import script from "./TruckTrackingItem.vue?vue&type=script&lang=js"
export * from "./TruckTrackingItem.vue?vue&type=script&lang=js"

import "./TruckTrackingItem.vue?vue&type=style&index=0&id=d1ab2214&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ab2214"]])

export default __exports__